export enum AccountRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  BILLING_MANAGER = 'BILLING_MANAGER',
}
